import styled from '@emotion/styled'

import { formControlReset } from 'styles/reset'

const Select = styled.select`
	${formControlReset}
	padding: 4px 8px;
	display: grid;
	color: inherit;
	border-radius: ${({ theme }) => theme.borderRadiuses.md};
	background-color: ${({ theme }) => theme.colors.light.surfaceVariant};
	background-image: url('/images/chevron-down.svg');
	background-repeat: no-repeat;
	background-position: ${({ theme }) => `right ${theme.spaces.space4} center`};
	${({ theme }) => theme.typography.caption}
	cursor: pointer;

	&:disabled {
		cursor: not-allowed;
	}

	&:focus {
		outline-style: solid;
		outline-width: 1px;
		outline-color: ${({ theme }) => theme.colors.light.accent};
	}
`

export default Select
